import exportSisoRequest from '@domain/model/request/siso/exportSisoRequest';
import getExportSisoTable from '@hooks/siso/getExportSisoTable';

const onExportSisoTable = ({ fileName, filters, table }) => {
    const queries = exportSisoRequest({ ...filters, ...table });
    return getExportSisoTable({ fileName, queries });
};

export default onExportSisoTable;
